import { Navigate } from 'react-router-dom';
import { getUser } from '../services/authService';
import { AppRoutes } from '../constants/appRoutes';

export const CheckLogin = ({ children }) => {
	const user = getUser();
	if (!user?.isApproved || !user?.OtpVerified) {
		return <Navigate to={`/${AppRoutes.Login}`}></Navigate>;
	}

	return children;
};

export const AlreadyLogin = ({ children }) => {
	const user = getUser();
	if (user?.isApproved && user?.OtpVerified) {
		return <Navigate to="/"></Navigate>;
	}

	return children;
};
